import { render, staticRenderFns } from "./SpreadViewerDesignOptions.vue?vue&type=template&id=28b94109"
import script from "./SpreadViewerDesignOptions.vue?vue&type=script&lang=js"
export * from "./SpreadViewerDesignOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28b94109')) {
      api.createRecord('28b94109', component.options)
    } else {
      api.reload('28b94109', component.options)
    }
    module.hot.accept("./SpreadViewerDesignOptions.vue?vue&type=template&id=28b94109", function () {
      api.rerender('28b94109', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/spread-viewer-options/SpreadViewerDesignOptions.vue"
export default component.exports